import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteSellersService = async (sellerId: string): Promise<void> => {
  await cjPontanegraApi.delete(`/sellers/${sellerId}`);
};
